import { displayFunctions } from '../../../utils/chartsUtils';

export const data = {
  plots: {
    posts_per_day_plot: {
      posts_per_day_plot: {
        trend: 1,
        values: [1, 2, 0, 0, 5, 4, 1],
        displayValue: displayFunctions.sum([1, 2, 0, 0, 5, 4, 1])
      }
    },

    additionalData: {
      posts_per_day: {
        trend: -1,
        values: [0, 0, 1, 0, 0, 2, 1],
        displayValue: 3
      }
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays(): any {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
